export * from './news.component';
